module.exports = __webpack_public_path__ + "img/icon-shezhi.56144712.svg";